
import React from 'react';
import axios from 'axios';
import { Typography, Drawer, Container, Box, IconButton, Tooltip, Button } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CDDSparkline from './DataDisplay/CDDSparkline';
import * as settings from "../../settings"
import { RedistrictingData, RedistrictingDataID } from "../../atom/atom"
import {
    useSetRecoilState,
    useRecoilState
} from 'recoil';

export default function SidebarDrawer(props) {
    const sidebarSettings = props.sidebarSettings
    const drawerWidth = "240px"
    const drawerStyles = {
        textAlign: "left",
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
            ml: { xs:"0", sm:"33.3333%", md:"29.166667%", lg:"25%" },
            width: drawerWidth,
            border: "none",
            boxShadow: 1,
            backgroundColor: "grey.light",
        },
    }
    const [redistrictingdata, setRedistrictingData] = useRecoilState(RedistrictingData)
    const setRedistrictingDataID = useSetRecoilState(RedistrictingDataID)

    function isEmpty(obj) {
        return Object.keys(obj).length === 0;
    }

    const [enrollment, setEnrollment] = React.useState({})
    const [data, setData] = React.useState([])

    React.useEffect(() => {
        if (sidebarSettings.school.ncessch) {
            axios
            .get(`${settings.API_SERVER}/api/nces/history/${sidebarSettings.school.ncessch}`)
            .then((res) => {
                setEnrollment(res.data)
                var tempData = []
                res.data.map((row) => {
                    tempData.push(row.total)
                })
                setData(tempData)
            })
            .catch((err) => {
                console.log(err)
            })
        }
    }, [sidebarSettings.school])

    function getDemographicData() {
        const nextID = redistrictingdata.length

        axios
        .get(`${settings.API_SERVER}/api/nces/history/${sidebarSettings.school.ncessch}`)
        .then((res) => {
            setRedistrictingData([...redistrictingdata, res.data])
            setRedistrictingDataID(nextID)
            console.log(res.data)
        })
        .catch((err) => {
            console.log(err)
        })
    }
    
    return (
        <Drawer
            sx={drawerStyles}
            variant="persistent"
            anchor="left"
            open={sidebarSettings.drawerOpen}
            transitionDuration={0}
        >
            <Box m="16px" sx={{ justifyContent:"space-between", alignItems: "center"  }} display="flex" >
                <Typography>School data</Typography>
                    <IconButton
                        aria-label="open drawer"
                        edge="end"
                        onClick={() => {sidebarSettings.setDrawerOpen(!sidebarSettings.drawerOpen)}}
                        sx={{ width: "36px", height: "36px" }}
                    >
                        { sidebarSettings.drawerOpen ? 
                            <ChevronLeftIcon />
                            : <ChevronRightIcon />
                        }
                    </IconButton>
            </Box>
            {!isEmpty(sidebarSettings.school) ?
            <Container spacing={1} disableGutters sx={{ padding: "0 16px 0 16px" }} >
                <Typography variant="h6" sx={{ lineHeight:"1.5rem" }}>{sidebarSettings.school.name}</Typography>
                {sidebarSettings.school.ncessch ? 
                <Typography variant="body2" color="primary">{`NCES ID: ${sidebarSettings.school.ncessch}`}</Typography>
                : null
                }
                <CDDSparkline data={data} enrollment={enrollment} />
                <Button onClick={getDemographicData}>Get demographic data</Button>
            </Container>
            : <Typography variant="body2" m="0 16px 0 16px">Select a school to view data.</Typography>}
        </Drawer>
    )
}